import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconEnvelopRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.502 5a2.5 2.5 0 0 0-2.5 2.5v9a2.5 2.5 0 0 0 2.5 2.5h13a2.5 2.5 0 0 0 2.5-2.5v-9a2.5 2.5 0 0 0-2.5-2.5h-13Zm-.5 6v5.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V11l-5.5 4.125a2.5 2.5 0 0 1-3 0L5.002 11Zm14-2.5v-1a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v1l6.7 5.025a.5.5 0 0 0 .6 0l6.7-5.025Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconEnvelopRoundLine);
export default Memo;
